import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { LAYOUT_MODE, LAYOUT_VERTICAL, SIDEBAR_COLOR, SIDEBAR_SIZE_SMALL, TOPBAR } from '@shared/models/layouts';
import { Router } from '@angular/router';
import { MenuService } from '@layouts/menu/menu.service';
import { TicketManager } from '@routes/ticket-manager';
import { MenuItem } from '@layouts/menu/menu.model';
import * as _ from 'lodash-es';
import Roles from '@shared/constants/roles';
import { AuthService } from '@core/auth/auth.service';
import { PopupService } from '@shared/services/popup-service';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit, AfterViewInit, OnDestroy {

  layoutType!: string;
  layoutMode!: string;
  sidebarcolor!: string;
  sidebarsize!: string;
  topbar!: string;

  isSupport = false;

  selectedMenu: MenuItem;

  private alive = true;

  constructor(private menuService: MenuService,
              private modalService: BsModalService,
              private ticketManager: TicketManager,
              private authService: AuthService,
              private popupService: PopupService,
              private router: Router) {
    this.isSupport = router.url.includes('support') || router.url.includes('auth');
    const url = router.url.split('/');
    const last = _.last(url);
    if (!last) {
      const roles = this.authService.getRolesByCompany();
      let url = '/concealed-damage';
      if (_.intersection(Roles.summaryView, roles).length) {
        url = '/summary';
      }
      this.router.navigate([url]);
    }
  }

  ngOnInit(): void {
    document.body.setAttribute('data-layout', 'vertical');

    this.layoutMode = LAYOUT_MODE;
    // default settings
    this.layoutType = LAYOUT_VERTICAL;
    this.sidebarcolor = SIDEBAR_COLOR;
    this.sidebarsize = SIDEBAR_SIZE_SMALL;
    this.topbar = TOPBAR;

    this.LayoutMode(this.layoutMode);
    this.SidebarColor(this.sidebarcolor);
    this.SidebarSize(this.sidebarsize);
  }

  ngAfterViewInit() {
    if (this.authService.isAuthenticated()) {
      this.popupService.checkPopupMessage(this.modalService);
    }
  }

  ngOnDestroy() {
    this.alive = false;
  }

  /**
   * Layout Mode Set
   */
  LayoutMode(mode: string) {
    switch (mode) {
      case 'light':
        document.body.setAttribute('data-sidebar', 'light');
        document.body.setAttribute('data-layout-mode', 'light');
        document.body.setAttribute('data-topbar', 'light');
        break;
      case 'dark':
        document.body.setAttribute('data-sidebar', 'dark');
        document.body.setAttribute('data-layout-mode', 'dark');
        document.body.setAttribute('data-topbar', 'dark');
        break;
      default:
        document.body.setAttribute('data-layout-mode', 'light');
        document.body.setAttribute('data-topbar', 'light');
        break;
    }
  }

  /**
   * Layout Sidebar Color Set
   */
  SidebarColor(color: string) {
    switch (color) {
      case 'light':
        document.body.setAttribute('data-sidebar', 'light');
        break;
      case 'dark':
        document.body.setAttribute('data-sidebar', 'dark');
        break;
      case 'brand':
        document.body.setAttribute('data-sidebar', 'brand');
        break;
      default:
        document.body.setAttribute('data-sidebar', 'light');
        break;
    }
  }

  /**
   * Layout Sidebar Size Set
   */
  SidebarSize(size: string) {
    switch (size) {
      case 'default':
        document.body.setAttribute('data-sidebar-size', 'lg');
        break;
      case 'compact':
        document.body.setAttribute('data-sidebar-size', 'md');
        break;
      case 'small':
        document.body.setAttribute('data-sidebar-size', 'sm');
        break;
      default:
        document.body.setAttribute('data-sidebar-size', 'lg');
        break;
    }
  }

  onClickEvent(ev) {
    if (!ev) {
      return
    }
    this.selectedMenu = ev;
  }

}
